export interface SerialNumberType {
    template: string;
    name: string;
    fields: {
        [key: string]: string;
    },
    type: string;
    description?: string;
    version?: string;
    tapeImg?: string;
    compatibility?: "legacy";
};

export const types: { [key: string]: SerialNumberType } = {
    "stella-bio-battery": {
        template: "Stella BIO/Serial sticker Battery/Battery TZe-S221 9mm 20201022.svg",
        name: "Stella BIO - Battery",
        fields: {
            "field-serial": "serial-database"
        },
        tapeImg: "8.jpg",
        type: "SB-Battery",
    },
    "stella-bio-hardcase": {
        template: "Stella BIO/Serial sticker Hardcase/Serial sticker Hardcase Brother TZe-145 18mm 20201022.svg",
        name: "Stella BIO - Hardcase",
        fields: {
            "field-serial": "serial-database"
        },
        type: "SB-Hardcase"
    },
    "stella-bio-fastening-belt-pl": {
        template: "Stella BIO/Serial sticker Fastening Belt/Fastening Belt PL Brother TZe-S221 9mm 20201022.svg",
        name: "Stella BIO - Fastening Belt PL",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "8.jpg",
        type: "SB-Belt-Abdomen"
    },
    "stella-bio-fastening-belt-us": {
        template: "Stella BIO/Serial sticker Fastening Belt/Fastening Belt US Brother TZe-S221 9mm 20201022.svg",
        name: "Stella BIO - Fastening Belt US",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "8.jpg",
        type: "12"
    },
    "stella-bio-usb-cable": {
        template: "Stella BIO/Serial sticker USB cable/Serial sticker USB cable Brother TZe-223 9mm 20201022.svg",
        name: "Stella BIO - USB Cable",
        fields: {
            "field-serial": "serial-database"
        },
        tapeImg: "11.jpg",
        type: "SB-MicroUSB-0m8"
    },
    "stella-bio-psu-plug": {
        template: "Stella BIO/Serial sticker PSU plug/PSU plug Brother TZe-S221 9mm 20201022.svg",
        name: "Stella BIO - PSU Plug",
        fields: {
            "field-serial": "serial-database"
        },
        tapeImg: "8.jpg",
        type: "SB-PSU-10W"
    },
    "stella-bio-charger": {
        template: "Stella BIO/Serial sticker Charger/Charger TZe-S221 9mm 20201022.svg",
        name: "Stella BIO - Charger",
        fields: {
            "field-serial": "serial-database"
        },
        tapeImg: "8.jpg",
        type: "SB-Charger"
    },
    "stella-bio-emg-plug-6+2": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 6+2 Brother YZe-131 12mm 20201022.svg",
        name: "Stella BIO - EMG Plug 6+2",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-6+2-1m3"
    },
    "stella-bio-emg-plug-1+2": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 1+2 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 1+2",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-1+2-1m3"
    },
    "stella-bio-emg-plug-8+0": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 8+0 Brother YZe-131 12mm 20201022.svg",
        name: "Stella BIO - EMG Plug 8+0",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-8+0-1m3"
    },
    "stella-bio-emg-plug-1+1": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 1+1 Brother YZe-131 12mm 20201014.svg",
        name: "Stella BIO - EMG Plug 1+1",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-1+1-1m3"
    },
    "stella-bio-emg-plug-4+2": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 4+2 Brother YZe-131 12mm 20201022.svg",
        name: "Stella BIO - EMG Plug 4+2",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-4+2-1m3"
    },
    "stella-bio-emg-plug-2+2": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 2+2 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 2+2",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-2+2-1m3"
    },
    "stella-bio-emg-plug-4+1": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 4+1 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 4+1",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-4+1-1m3"
    },
    "stella-bio-emg-plug-0+1": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 0+1 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 0+1",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-0+1-1m3"
    },
    "stella-bio-emg-plug-1+0": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 1+0 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 1+0",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-1+0-1m3"
    },
    "stella-bio-emg-plug-0+2": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 0+2 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 0+2",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-0+2-1m3"
    },
    "stella-bio-emg-plug-2+1": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 2+1 Brother YZe-131 12mm 20201022.svg",
        name: "Stella BIO - EMG Plug 2+1",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-2+1-1m3"
    },
    "stella-bio-emg-plug-3+0": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 3+0 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 3+0",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-3+0-1m3"
    },
    "stella-bio-emg-plug-2+0": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 2+0 Brother YZe-131 12mm 20201022.svg",
        name: "Stella BIO - EMG Plug 2+0",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-2+0-1m3"
    },
    "stella-bio-emg-plug-4+0": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 4+0 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 4+0",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-4+0-1m3"
    },
    "stella-bio-emg-plug-3+1": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 3+1 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 3+1",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-3+1-1m3"
    },
    "stella-bio-emg-plug-7+1": {
        name: "Stella BIO - EMG Plug 7+1",
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 7+1 Brother YZe-131 12mm 20201022.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-7+1-1m3"
    },
    "stella-bio-emg-plug-3+2": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 3+2 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 3+2",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-3+2-1m3"
    },
    "stella-bio-emg-plug-5+0": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 5+0 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 5+0",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-5+0-1m3"
    },
    "stella-bio-emg-plug-5+1": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 5+1 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 5+1",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-5+1-1m3"
    },
    "stella-bio-emg-plug-6+0": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 6+0 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 6+0",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-6+0-1m3"
    },
    "stella-bio-emg-plug-5+2": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 5+2 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 5+2",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-5+2-1m3"
    },
    "stella-bio-emg-plug-6+1": {
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 6+1 Brother YZe-131 12mm 20201027.svg",
        name: "Stella BIO - EMG Plug 6+1",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-6+1-1m3"
    },
    "stella-bio-emg-plug-7+0": {
        name: "Stella BIO - EMG Plug 7+0",
        template: "Stella BIO/Serial sticker EMG plug/Serial sticker EMG plug 7+0 Brother YZe-131 12mm 20201027.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "26.jpg",
        type: "ACC-EMG-EMS-7+0-1m3"
    },
    // Luna EMG
    "luna-emg-serial": {
        name: "Luna EMG - Rehabilitation Robot",
        template: "Luna EMG/Luna EMG serial sticker.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        tapeImg: "",
        type: "LunaEMG",
        description: "Luna EMG Rehabilitation Robot",
        version: "1.0.7.1",
        compatibility: "legacy"
    },
    "luna-emg-extension-forearm": {
        name: "Luna EMG - Forearm Extension",
        template: "Luna EMG/Extensions/Forearm Extension for LUNA EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-Ext-01",
        description: "Forearm extension",
        version: "LEExt_01_04",
        compatibility: "legacy"
    },
    "luna-emg-extension-upper-limb": {
        name: "Luna EMG - Upper Extremity Extension",
        template: "Luna EMG/Extensions/Upper Limb extension for LUNA EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-Ext-02",
        description: "Upper extremity extension",
        version: "LEExt_02_06",
        compatibility: "legacy"
    },
    "luna-emg-extension-steering-wheel": {
        name: "Luna EMG - Steering Wheel Extension",
        template: "Luna EMG/Extensions/Steering wheel extension for LUNA EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-Ext-03",
        description: "Steering wheel extension",
        version: "LEExt_03_04",
        compatibility: "legacy"
    },
    "luna-emg-extension-lower-limb": {
        name: "Luna EMG - Lower Limb Extension",
        template: "Luna EMG/Extensions/Lower limb extension for LUNA EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-Ext-04",
        description: "Lower limb extension",
        version: "LEExt_04_03",
        compatibility: "legacy"
    },
    "luna-emg-extension-ankle": {
        name: "Luna EMG - Ankle extension",
        template: "Luna EMG/Extensions/Ankle extension for LUNA EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-Ext-05",
        description: "Ankle extension",
        version: "LEExt_05_08",
        compatibility: "legacy"
    },
    "luna-emg-extension-shoulder": {
        name: "Luna EMG - Shoulder Extension",
        template: "Luna EMG/Extensions/Shoulder extension for LUNA EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-Ext-06",
        description: "Shoulder extension",
        version: "LEExt_06_01",
        compatibility: "legacy"
    },
    "luna-emg-extension-disc-pediatric": {
        name: "Luna EMG - Disc Extension - Pediatric",
        template: "Luna EMG/Extensions/Disc extension - pediatric.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-ExtOT-01",
        description: "Disc extension - pediatric",
        version: "LEExt_OT_01_04",
        compatibility: "legacy"
    },
    "luna-emg-extension-disc-small": {
        name: "Luna EMG - Disc Extension - Small",
        template: "Luna EMG/Extensions/Disc extension - small.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-ExtOT-02",
        description: "Disc extension - small",
        version: "LEExt_OT_02_04",
        compatibility: "legacy"
    },
    "luna-emg-extension-disc-medium": {
        name: "Luna EMG - Disc Extension - Medium",
        template: "Luna EMG/Extensions/Disc extension - medium.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-ExtOT-03",
        description: "Disc extension - medium",
        version: "LEExt_OT_03_04",
        compatibility: "legacy"
    },
    "luna-emg-extension-disc-large": {
        name: "Luna EMG - Disc Extension - Large",
        template: "Luna EMG/Extensions/Disc extension - large.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-ExtOT-04",
        description: "Disc extension - large",
        version: "LEExt_OT_04_04",
        compatibility: "legacy"
    },
    "luna-emg-extension-screwdriver-medium": {
        name: "Luna EMG - Screwdriver Extension - Medium",
        template: "Luna EMG/Extensions/Screwdriver extension - medium.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-ExtOT-05",
        description: "Screwdriver extension - medium",
        version: "LEExt_OT_05_04",
        compatibility: "legacy"
    },
    "luna-emg-extension-screwdriver-large": {
        name: "Luna EMG - Screwdriver Extension - Large",
        template: "Luna EMG/Extensions/Screwdriver extension - large.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-ExtOT-06",
        description: "Screwdriver extension - large",
        version: "LEExt_OT_06_04",
        compatibility: "legacy"
    },
    "luna-emg-extension-screwdriver-small": {
        name: "Luna EMG - Screwdriver Extension - Small",
        template: "Luna EMG/Extensions/Screwdriver extension - small.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-ExtOT-07",
        description: "Screwdriver extension - small",
        version: "LEExt_OT_07_04",
        compatibility: "legacy"
    },
    "luna-emg-extension-key-small": {
        name: "Luna EMG - Key Extension – Small",
        template: "Luna EMG/Extensions/Key extension - small.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-ExtOT-08",
        description: "Key extension – small",
        version: "LEExt_OT_08_04",
        compatibility: "legacy"
    },
    "luna-emg-extension-key-large": {
        name: "Luna EMG - Key Extension – Large",
        template: "Luna EMG/Extensions/Key extension - large.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-ExtOT-09",
        description: "Key extension – large",
        version: "LEExt_OT_09_04",
        compatibility: "legacy"
    },
    "luna-emg-extension-occupational-therapy": {
        name: "Luna EMG - OT Extension Set",
        template: "Luna EMG/Extensions/Occupational therapy extensions for LUNA EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-ExtOT-Set",
        description: "OT extension set",
        version: "LEExt_OT_Set_01",
        compatibility: "legacy"
    },
    "luna-emg-tv-set": {
        name: "Luna EMG - TV Kit",
        template: "Luna EMG/Accessories/TV set for LUNA EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LETVKit",
        description: "Luna EMG TV Kit",
        version: "ACC_09_TVKit_01",
        compatibility: "legacy"
    },
    "luna-emg-exercise-chair": {
        name: "Luna EMG - Chair",
        template: "Luna EMG/Accessories/Exercise chair for LUNA EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LESeat",
        description: "Luna EMG seating system",
        version: "ACC_07_Chair_01",
        compatibility: "legacy"
    },
    "luna-emg-glove": {
        name: "Luna EMG - Glove",
        template: "Luna EMG/Accessories/Glove for LUNA EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "ACC_08_Glove",
        description: "Glove for LUNA EMG",
        version: "ACC_08_Glove_01",
        compatibility: "legacy"
    },
    "luna-emg-remote-control": {
        name: "Luna EMG - Remote control with a safety button for the patient",
        template: "Luna EMG/Accessories/Remote control with a safety button for the patient.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-EStop",
        description: "Patient's emergency stop and controller",
        version: "ACC_10_PilotLEEStop_01",
        compatibility: "legacy"
    },
    "luna-emg-power-cord-10m-eu-plug": {
        name: "Luna EMG - 10 m power cord (EU plug)",
        template: "Luna EMG/Accessories/10 m power cord (EU plug).svg",
        fields: {
            "field-date": "today"
        },
        type: "ACC-AC-EF-10m",
        description: "10 m power cord (EU plug)",
        version: "ACC_06.01_CableAC_EU_01",
        compatibility: "legacy"
    },
    "luna-emg-power-cord-10m-uk-plug": {
        name: "Luna EMG - 10 m power cord (UK plug)",
        template: "Luna EMG/Accessories/10 m power cord (UK plug).svg",
        fields: {
            "field-date": "today"
        },
        type: "ACC-AC-G-10m",
        description: "10 m power cord (UK plug)",
        version: "ACC_06.02_CableAC_UK_01",
        compatibility: "legacy"
    },
    "luna-emg-power-cord-10m-type-i-plug": {
        name: "Luna EMG - 10 m power cord (type I plug)",
        template: "Luna EMG/Accessories/10 m power cord (type I plug ).svg",
        fields: {
            "field-date": "today"
        },
        type: "ACC-AC-I-10m",
        description: "10 m power cord (type I plug)",
        version: "ACC_06.03_CableAC_I_01",
        compatibility: "legacy"
    },
    "luna-emg-power-cord-10m-type-k-plug": {
        name: "Luna EMG - 10 m power cord (type K plug)",
        template: "Luna EMG/Accessories/10 m power cord (type K plug).svg",
        fields: {
            "field-date": "today"
        },
        type: "ACC-AC-K-10m",
        description: "10 m power cord (type K plug)",
        version: "ACC_06.04_CableAC_K_01",
        compatibility: "legacy"
    },
    "luna-emg-power-cord-10m-type-b-plug": {
        name: "Luna EMG - 10 m power cord (type B plug)",
        template: "Luna EMG/Accessories/10 m power cord (type B plug).svg",
        fields: {
            "field-date": "today"
        },
        type: "ACC-AC-B-10m",
        description: "10 m power cord (type B plug)",
        version: "ACC_06.05_CableAC_B_01",
        compatibility: "legacy"
    },
    "luna-emg-power-cord-2m-eu-plug": {
        name: "Luna EMG - 2 m power cord (EU plug)",
        template: "Luna EMG/Accessories/2 m power cord (EU plug).svg",
        fields: {
            "field-date": "today"
        },
        type: "ACC_06.10_CableAC_2m_EU",
        description: "2 m power cord (EU plug)",
        version: "ACC_06.10_CableAC_2m_EU_01",
        compatibility: "legacy"
    },
    "luna-emg-power-cord-2m-uk-plug": {
        name: "Luna EMG - 2 m power cord (UK plug)",
        template: "Luna EMG/Accessories/2 m power cord (UK plug).svg",
        fields: {
            "field-date": "today"
        },
        type: "ACC_06.11_CableAC_2m_UK",
        description: "2 m power cord (UK plug)",
        version: "ACC_06.11_CableAC_2m_UK_01",
        compatibility: "legacy"
    },
    "luna-emg-cable-1+1": {
        name: "Luna EMG - EMG Plug 1+1",
        template: "Luna EMG/EMG Cables/EMG cable 1+1 channels for Luna EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-EMG-1+1-1m5",
        description: "Patient EMG 1+1 channel cable 1,5m length, MDR26",
        version: "ACC_03.01_EMGcable_1+1_1,5m_01",
        compatibility: "legacy"
    },
    "luna-emg-cable-2": {
        name: "Luna EMG - EMG Plug 2+0",
        template: "Luna EMG/EMG Cables/EMG cable 2+0 channels for Luna EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-EMG-2+0-1m5",
        description: "Patient EMG 2 channel cable 1,5m length, MDR26",
        version: "ACC_03.02_EMGcable_2+0_1,5m_01",
        compatibility: "legacy"
    },
    "luna-emg-cable-5+1": {
        name: "Luna EMG - EMG Plug 5+1",
        template: "Luna EMG/EMG Cables/EMG cable 5+1 channels for Luna EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-EMG-5+1-1m5",
        description: "Patient EMG 5+1 channel cable 1,5m length, MDR26",
        version: "ACC_03.03_EMGcable_5+1_1,5m_01",
        compatibility: "legacy"
    },
    "luna-emg-cable-6": {
        name: "Luna EMG - EMG Plug 6+0",
        template: "Luna EMG/EMG Cables/EMG cable 6+0 channels for Luna EMG.svg",
        fields: {
            "field-serial": "serial-database",
            "field-date": "today"
        },
        type: "LE-EMG-6+0-1m5",
        description: "Patient EMG 6 channel cable 1,5m length, MDR26",
        version: "ACC_03.04_EMGcable_6+0_1,5m_01",
        compatibility: "legacy"
    },
    "luna-emg-hardcase": {
        name: "Luna EMG - Hardcase",
        template: "Luna EMG/Luna EMG Hardcase.svg",
        fields: {
            "field-serial": "serial-database"
        },
        type: "LE-Hardcase",
        description: "Luna EMG Hardcase",
        version: "ACC_01.00.01_skrzynia_glowna_LunaEMG",
        compatibility: "legacy"
    }
}
